var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPendingReviewsMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6758_17051)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 12,
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 11.2,
    stroke: "#09268C",
    strokeWidth: 1.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6663 4.33398C14.8857 4.33398 14.2479 4.53119 13.7593 4.92355C13.2755 5.31209 13.0082 5.83574 12.8586 6.35918C12.7987 6.56884 12.7559 6.7846 12.7255 7.00065H12.6663C10.8254 7.00065 9.33301 8.49304 9.33301 10.334V14.334C9.33301 16.1749 10.8254 17.6673 12.6663 17.6673H19.333C21.174 17.6673 22.6663 16.1749 22.6663 14.334V10.334C22.6663 8.49304 21.174 7.00065 19.333 7.00065H18.9195C18.8822 6.77556 18.83 6.55034 18.7571 6.3315C18.5784 5.79553 18.2677 5.27656 17.7333 4.89892C17.2015 4.52311 16.5143 4.33398 15.6663 4.33398ZM17.6775 8.33398C17.6777 8.50418 17.6748 8.67023 17.6719 8.83701V8.83706C17.6691 9.00046 17.6663 9.16457 17.6663 9.33398C17.6663 9.70217 17.9648 10.0007 18.333 10.0007C18.7012 10.0007 18.9997 9.70217 18.9997 9.33398C18.9997 9.20949 19.002 9.0666 19.0045 8.91308C19.0074 8.73071 19.0107 8.53333 19.0105 8.33398H19.333C20.4376 8.33398 21.333 9.22941 21.333 10.334V14.334C21.333 15.4386 20.4376 16.334 19.333 16.334H12.6663C11.5618 16.334 10.6663 15.4386 10.6663 14.334V10.334C10.6663 9.23373 11.5548 8.34098 12.6534 8.33403C12.6543 8.51611 12.6575 8.69807 12.6605 8.86798V8.868L12.6605 8.86802C12.6635 9.03977 12.6663 9.1992 12.6663 9.33398C12.6663 9.70217 12.9648 10.0007 13.333 10.0007C13.7012 10.0007 13.9997 9.70217 13.9997 9.33398C13.9997 9.14609 13.9963 8.96726 13.9929 8.789L13.9929 8.78891C13.99 8.63856 13.9872 8.48862 13.9864 8.33398H17.6775ZM17.5613 7.00065C17.5415 6.91486 17.5186 6.83226 17.4922 6.75314C17.3792 6.4141 17.2107 6.16225 16.9638 5.9878C16.7144 5.81153 16.3183 5.66732 15.6663 5.66732C15.1136 5.66732 14.793 5.80345 14.5941 5.96317C14.3905 6.12671 14.2411 6.3739 14.1407 6.72546C14.1156 6.81326 14.0943 6.90513 14.0762 7.00065H17.5613ZM15.9997 10.334C16.3679 10.334 16.6663 10.6325 16.6663 11.0007V12.922L18.2978 13.7377C18.6271 13.9024 18.7606 14.3028 18.596 14.6321C18.4313 14.9614 18.0309 15.0949 17.7015 14.9303L15.333 13.746V11.0007C15.333 10.6325 15.6315 10.334 15.9997 10.334Z",
    fill: "#09268C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6758_17051",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6758_17051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6758_17051",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendingReviewsMap);
export default __webpack_public_path__ + "static/media/ic_pending-reviews-map.7cca63b9e1e3c187ede79e2333272f02.svg";
export { ForwardRef as ReactComponent };